import { CELL_DECORATORS_ACTIONS, CELL_ACTION_TYPES } from "../actions/cellDecorators";
import produce, { enableES5} from "immer"

enableES5();

export interface CellDecoratorsType {
  blink: boolean
}

export interface CellDecoratorsState {
  [key: number]: CellDecoratorsType
}

export const initialDecoratorsSettings: CellDecoratorsType = {
  blink: false
}

export default (state: CellDecoratorsState = {}, action: CELL_ACTION_TYPES): CellDecoratorsState => {

  return produce(state, (draft: CellDecoratorsState) => {
    // If the cell decorators don't exist yet, initualize them with the defaults first.
    if (typeof draft[action.cellId] === "undefined") {
      draft[action.cellId] = initialDecoratorsSettings;
    }

    switch (action.type) {
      case CELL_DECORATORS_ACTIONS.BLINK_CELL_STARTED:
        draft[action.cellId] = {
          ...draft[action.cellId],
          blink: true
        }
        break;
      case CELL_DECORATORS_ACTIONS.BLINK_CELL_STOPPED:
        draft[action.cellId] = {
          ...draft[action.cellId],
          blink: false
        }
        break;
    };
  });
}